import { injectIntl } from "react-intl";
import React from "react";

const SearchLine = (props) => {

    return (
        <div className={ "flex px-6 gap-3 items-center" }>
            <button className={ "SecondaryButton" } onClick={ () => props.setSearch("") }>
                <img alt={ "Logo" } src={ "/media/icons/arrowLeft.svg" } className={ "w-4 h-4" }/>
                Back
            </button>
            <div className={"SearchLineDivider"}></div>
            <div className={ "SearchLineText" }>
                Search Result for “{ props.search }”
            </div>
        </div>
    )
}

export default injectIntl(SearchLine);